import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import ExpensesListPage from './Features/ExpensesList'

const ExpensesPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Expense', 'expense') ? <ExpensesListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default ExpensesPage
